"use strict";
/**
 * Arbitrage monitor API helpers
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonitorPairs = getMonitorPairs;
exports.getMonitorStatus = getMonitorStatus;
exports.addMonitorPair = addMonitorPair;
exports.removeMonitorPair = removeMonitorPair;
exports.setMonitorOrderMode = setMonitorOrderMode;
const request_1 = require("./request");
async function getMonitorPairs() {
    return (0, request_1.apiRequest)("GET", "/arbitrage-monitor/pairs");
}
async function getMonitorStatus() {
    return (0, request_1.apiRequest)("GET", "/arbitrage-monitor/status");
}
async function addMonitorPair(pair) {
    return (0, request_1.apiRequest)("POST", "/arbitrage-monitor/pairs", { body: pair });
}
async function removeMonitorPair(pair) {
    return (0, request_1.apiRequest)("DELETE", "/arbitrage-monitor/pairs", { body: pair });
}
async function setMonitorOrderMode(orderMode) {
    return (0, request_1.apiRequest)("POST", "/arbitrage-monitor/settings", { body: { orderMode } });
}
